import * as React from 'react';
import Paper from '@mui/material/Paper';
import Table from '@mui/material/Table';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import { Box, Button, Menu, MenuItem, TableBody, Typography } from '@mui/material';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';
import Row from 'react-bootstrap/Row';
import { useState } from 'react';
import axios from 'axios'
import Swal from 'sweetalert2';
import { FaEdit, FaTrash, FaUserCircle } from 'react-icons/fa';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import IconButton from '@mui/material/IconButton';
import Fade from '@mui/material/Fade';
import Pagination from 'react-bootstrap/Pagination';


export default function Payment() {

    const [DownPayment, setDownPayment] = useState()
    const [Instalment1, setInstalment1] = useState()
    const [Instalment2, setInstalment2] = useState()
    const [Instalment3, setInstalment3] = useState()
    const [FinalPayment, setFinalPayment] = useState()
    const [ProjectName, setProjectName] = useState()
    const [id, setId] = useState()

    
    const [downPaymentValid, setDownPaymentValid] = useState(true);
    const [Instalment1tValid, setInstalment1Valid] = useState(true);
    const [Instalment2Valid, setInstalment2Valid] = useState(true);
    const [Instalment3Valid, setInstalment3Valid] = useState(true);
    const [finalPaymentValid, setFinalPaymentValid] = useState(true);

    const add_payment = () => {
        axios.post("https://buildfastvapi.emedha.in/project/api/v1/add-payment", {
            DownPayment, Instalment1, Instalment2, Instalment3, ProjectName, FinalPayment
        }).then((res) => {
            if (res.data.status === 200) {
                setOpen(false)
                get_payment()
                Swal.fire({
                    icon: 'success',
                    title: "Success !",
                    text: "Data added successfully !",
                    confirmButtonColor: "rgb(126, 110, 228)",
                    cancelButtonColor: "#d33",
                    showCancelButton: false,
                    confirmButtonText: "Ok"
                }).then((result) => {
                    if (result.value) {
                        return
                    }
                })
            }
        })
    }

    const [response1, setResponse1] = useState([])

    const get_basic = () => {
        axios.get("https://buildfastvapi.emedha.in/project/api/v1/get-basic").then((res) => {
            if (res.data.status === 200) {
                setResponse1(res.data.data)
            }
        })
    }

    const [response, setResponse] = useState([])

    const get_payment = () => {
        axios.get("https://buildfastvapi.emedha.in/project/api/v1/get-payment").then((res) => {
            if (res.data.status === 200) {
                setResponse(res.data.data)
            }
        })
    }


    React.useEffect(() => {
        get_payment()
        get_basic()
    }, [])

    const [anchorEl, setAnchorEl] = React.useState(null);
    const open2 = Boolean(anchorEl);

    const handleClick = (event) => {
        setAnchorEl(event);
    };

    const handleClose2 = () => {
        setAnchorEl(null);
    };

    const [open, setOpen] = useState(false)

    const handleClose = () => {
        setOpen(false);
        setValidated(false)
    };

    const [Validated, setValidated] = useState(false);

    const formValidation = (event) => {
        event.preventDefault()
        const form = event.currentTarget;
        if (form.checkValidity() === false) {
            event.preventDefault();
            event.stopPropagation();
        } else {
            add_payment()
        }

        setValidated(true);
    };


    const handleDownPaymentChange = (e) => {
        const enteredValue = e.target.value;
        const numericValue = parseFloat(enteredValue);

        if (isNaN(numericValue) || numericValue < 0 || numericValue > 100) {
           
            setDownPaymentValid(false);

        } else {
            setDownPayment(numericValue);
            setDownPaymentValid(true);
        }
    };

    const handleInstalment1Change = (e) => {
        const enteredValue = e.target.value;
        const numericValue = parseFloat(enteredValue);

        if (isNaN(numericValue) || numericValue < 0 || numericValue > 100) {
            setInstalment1Valid(false);
        } else {
            setInstalment1(numericValue);
            setInstalment1Valid(true);
        };
    }
    const handleFinalPaymentChange = (e) => {
        const enteredValue = e.target.value;
        const numericValue = parseFloat(enteredValue);

        if (isNaN(numericValue) || numericValue < 0 || numericValue > 100) {
            setFinalPaymentValid(false);
        } else {
            setFinalPayment(numericValue);
            setFinalPaymentValid(true);
        };
    }
    const handleInstalment2Change = (e) => {
        const enteredValue = e.target.value;
        const numericValue = parseFloat(enteredValue);

        if (isNaN(numericValue) || numericValue < 0 || numericValue > 100) {
            setInstalment2Valid(false);
        } else {
            setInstalment2(numericValue);
            setInstalment2Valid(true);
        };
    }
    const handleInstalment3Change = (e) => {
        const enteredValue = e.target.value;
        const numericValue = parseFloat(enteredValue);

        if (isNaN(numericValue) || numericValue < 0 || numericValue > 100) {
            setInstalment3Valid(false);
        } else {
            setInstalment3(numericValue);
            setInstalment3Valid(true);
        };
    }

    const deleteAlert = (id) => {
        handleClose2()
        Swal.fire({
            icon: 'warning',
            title: "Warning !",
            text: "Are you sure to delete this data",
            confirmButtonColor: "rgb(126, 110, 228)",
            cancelButtonColor: "#d33",
            showCancelButton: true,
            confirmButtonText: "Yes"
        }).then((result) => {
            if (result.value) {
                paymentDataDelete(id)
            }
        })
    }

    const paymentDataDelete = (id) => {
        axios.post('https://buildfastvapi.emedha.in/project/api/v1/delete-payment', {
            id
        }).then((res) => {
            if (res.data.status === 200) {
                get_payment()
                Swal.fire({
                    icon: 'success',
                    title: "Successfull !",
                    text: "payment is deleted successfully !",
                    confirmButtonColor: "rgb(126, 110, 228)",
                    cancelButtonColor: "#d33",
                    showCancelButton: false,
                    confirmButtonText: "Ok"
                }).then((result) => {
                    if (result.value) {
                        return
                    }
                })
            }
        })
    }

    const editAlert = () => {
        setOpen1(false)
        handleClose2()
        Swal.fire({
            icon: 'warning',
            title: "Warning !",
            text: "Are you sure to edit this data",
            confirmButtonColor: "green",
            cancelButtonColor: "#d33",
            showCancelButton: true,
            confirmButtonText: "Yes"
        }).then((result) => {
            if (result.value) {
                paymentDataEdit(id)
            }
        })
    }

    const paymentDataEdit = (id) => {
        axios.post('https://buildfastvapi.emedha.in/project/api/v1/payment-edit', {
            DownPayment, Instalment1, Instalment2, Instalment3, ProjectName, FinalPayment, id
        }).then((res) => {
            if (res.data.status === 200) {
                if (res.data.status === 200) {
                    get_payment()
                    Swal.fire({
                        icon: 'success',
                        title: "Successfull !",
                        text: "payment is updated successfully !",
                        confirmButtonColor: "rgb(126, 110, 228)",
                        cancelButtonColor: "#d33",
                        showCancelButton: false,
                        confirmButtonText: "Ok"
                    }).then((result) => {
                        if (result.value) {
                            return
                        }
                    })
                }
            }
        })
    }

    const [open1, setOpen1] = useState(false)

    const viewData = () => {
        axios.post('https://buildfastvapi.emedha.in/project/api/v1/view-payment', {
            id
        }).then((res) => {
            setProjectName(res.data.project)
            setDownPayment(res.data.DownPayment)
            setInstalment1(res.data.Instalment1)
            setInstalment2(res.data.Instalment2)
            setInstalment3(res.data.Instalment3)
            setFinalPayment(res.data.FinalPayment)
            setOpen1(true)
        })
    }

    const searchPayment = (text) => {
        axios.post('https://buildfastvapi.emedha.in/project/api/v1/search-payment', {
            text
        }).then((res) => {

            setResponse(res.data)

        })
    }

    return (
        <div>


            <div className='leadManagementTable'>
                <Paper elevation={0} >

                    <TableContainer sx={{ height: 95 + "vh", p: 0.3, pt: 2 }} >

                        {/* <Typography style={{ color: 'rgba(41, 16, 105, 1)', marginBottom: 3, marginLeft: 15.5, fontSize: 18, color: 'gray', fontWeight: '500' }}>Search Filter</Typography> */}

                        <div style={{ height: '0.1rem', borderBottom: '0.2px solid lightgray' }} ></div>
                        <div className='card mt-2' style={{ border: 'none', paddingLeft: 15, paddingRight: 15, flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center' }} >
                            <div>

                                <input onChange={(e) => searchPayment(e.target.value)} style={{ height: '2.3rem', color: 'gray', borderRadius: '0.3rem', outline: 'none', width: '26rem', border: '0.7px solid lightgray' }} placeholder='Search...' />
                            </div>
                            <div>
                                <Button onClick={() => setOpen(true)} style={{ width: '9rem', height: '2.3rem', backgroundColor: 'rgb(126, 110, 228)', color: 'white' }}>+ Add Project</Button>
                            </div>
                        </div>
                        <Table style={{ position: 'relative', top: '1.3rem' }}>
                            <TableHead sx={{ borderTop: '1px solid lightgray' }}>
                                <TableRow>
                                    <TableCell
                                        align={"start"}
                                        style={{ minWidth: 0, fontSize: 14, fontWeight: '600', color: 'gray', fontSize: 13 }}
                                    >
                                        Project Name
                                    </TableCell>
                                    <TableCell
                                        align={"start"}
                                        style={{ minWidth: 0, fontSize: 14, fontWeight: '600', color: 'gray', fontSize: 13 }}
                                    >
                                        Down Payment
                                    </TableCell>
                                    <TableCell
                                        align={"start"}
                                        style={{ minWidth: 0, fontSize: 14, fontWeight: '600', color: 'gray', fontSize: 13 }}
                                    >
                                        Instalment1
                                    </TableCell>
                                    <TableCell

                                        align={"start"}
                                        style={{ top: 57, fontWeight: '600', color: 'gray', fontSize: 13 }}
                                    >
                                        Instalment2
                                    </TableCell>
                                    <TableCell

                                        align={"left"}
                                        style={{ top: 57, fontWeight: '600', color: 'gray', fontSize: 13 }}
                                    >
                                        Instalment3
                                    </TableCell>

                                    <TableCell

                                        align={"left"}
                                        style={{ top: 57, fontWeight: '600', color: 'gray', fontSize: 13, }}
                                    >
                                        FinalPayment
                                    </TableCell>

                                    <TableCell

                                        align={"left"}
                                        style={{ top: 21, fontWeight: '600', color: 'gray', fontSize: 13, width: 21 }}
                                    >
                                        Action
                                    </TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>

                                {response
                                    .map((row) => {

                                        let color = ''
                                        let widths = ''

                                        if (row.lead === 'Not Customer') {
                                            color = 'red'
                                            widths = false
                                        }

                                        if (row.lead === 'Customer') {
                                            color = 'green'
                                            widths = true
                                        }


                                        return (
                                            <TableRow hover role="checkbox" tabIndex={-1} key={row.id}>

                                                <TableCell align={"start"}
                                                    style={{ top: 57, fontSize: 12 }}>{row.ProjectName}</TableCell>
                                                <TableCell align={"start"}
                                                    style={{ top: 57, fontSize: 12 }}>{row.DownPayment}%</TableCell>
                                                <TableCell align={"start"}
                                                    style={{ top: 57, fontSize: 12 }}>{row.Instalment1}%</TableCell>
                                                <TableCell align={"start"}
                                                    style={{ top: 57, fontSize: 12 }}>{row.Instalment2}%</TableCell>
                                                <TableCell align={"start"}
                                                    style={{ top: 57, fontSize: 12 }}>{row.Instalment3}%</TableCell>
                                                <TableCell align={"start"}
                                                    style={{ top: 57, fontSize: 12 }}>{row.FinalPayment}%</TableCell>

                                                <TableCell align={"start"}
                                                    style={{ top: 57, fontSize: 12, color: "rgb(126, 110, 228) " }}>

                                                    <div style={{ display: 'flex' }} >
                                                        {/* <Button onClick={() => deleteAlert(row.id)} style={{ backgroundColor: 'red', color: 'white', fontSize: 11, height: '1.7rem', position: 'relative', top: '0.4rem', left: '-0.2rem' }} >Delete</Button> */}
                                                        <div>
                                                            <IconButton
                                                                id="fade-button"
                                                                aria-controls={open2 ? 'fade-menu' : undefined}
                                                                aria-haspopup="true"
                                                                aria-expanded={open2 ? 'true' : undefined}
                                                                onClick={(e) => {
                                                                    handleClick(e.currentTarget)
                                                                    setId(row.id)
                                                                }}
                                                            >
                                                                <MoreVertIcon />
                                                            </IconButton>
                                                            <Menu
                                                                id="fade-menu"
                                                                MenuListProps={{
                                                                    'aria-labelledby': 'fade-button',
                                                                }}
                                                                anchorEl={anchorEl}
                                                                open={open2}
                                                                onClose={handleClose2}
                                                                TransitionComponent={Fade}
                                                            >

                                                                <MenuItem style={{ color: 'gray' }} onClick={() => {

                                                                    handleClose2()
                                                                    viewData(id)

                                                                }}><FaEdit style={{ marginRight: 4 }} /> Edit</MenuItem>

                                                                <MenuItem onClick={() => deleteAlert(id)} style={{ color: 'gray' }} ><FaTrash style={{ marginRight: 4 }} /> Delete</MenuItem>
                                                            </Menu>
                                                        </div>
                                                    </div>
                                                </TableCell>
                                            </TableRow>
                                        );
                                    })}
                            </TableBody>
                        </Table>
                        {
                            response.length === 0 && (
                                <Box className='card' style={{ border: 'none', height: '58vh', width: '100%', boxShadow: 'none', justifyContent: 'center', alignItems: 'center' }} >
                                    <img src='https://cdn-icons-png.flaticon.com/128/2291/2291944.png' width='145px' />
                                    <Typography>0 customers</Typography>
                                </Box>
                            )
                        }
                    </TableContainer>
                </Paper>
            </div>

            <div>
                <Dialog
                    style={{ borderTop: '12px solid rgb(126, 110, 228)' }}
                    maxWidth='xl'
                    open={open}
                    onClose={handleClose}
                    aria-labelledby="responsive-dialog-title"
                >
                    <DialogContent>
                        <div style={{ width: "37rem" }} >
                            <Form noValidate validated={Validated} onSubmit={formValidation} >
                                <div className='mb-4 mt-1'>
                                    <Typography style={{ textAlign: 'center', fontWeight: '500', color: 'rgb(126, 110, 228)', fontSize: 21 }}>Add Payment</Typography>
                                </div>
                                <Row className="mb-3">

                                    <Form.Group as={Col} md="12" controlId="validationCustom01">
                                        <Typography style={{ color: 'gray', fontSize: 13 }}>Project Name</Typography>
                                        <Form.Select
                                            required
                                            onChange={(e) => setProjectName(e.target.value)}
                                            type="text"
                                            style={{ padding: '0.42rem', marginBottom: 14 }}


                                        >
                                            <option>Select Project Name</option>

                                            {
                                                response1.map((data) => {
                                                    return (
                                                        <option>{data.ProjectName}</option>
                                                    )
                                                })
                                            }

                                        </Form.Select>
                                        <Form.Control.Feedback type="invalid">
                                            Please Enter Valid name
                                        </Form.Control.Feedback>
                                    </Form.Group>
                                    <Form.Group as={Col} md="12" controlId="validationCustom01">
                                        <Typography style={{ color: 'gray', fontSize: 13 }}>Down Payment</Typography>
                                        <Form.Control
                                            required
                                            value={DownPayment}
                                            onChange={(e) => handleDownPaymentChange(e)}
                                            type="number"
                                            maxLength="2"
                                            style={{ padding: '0.42rem', marginBottom: 14 }}
                                        />
                                        <Form.Control.Feedback type="invalid">
                                            Please Enter a valid down payment (up to 100%)
                                        </Form.Control.Feedback>
                                    </Form.Group>


                                    <Form.Group as={Col} md="4" controlId="validationCustom01">
                                        <Typography style={{ color: 'gray', fontSize: 13 }}>Instalment1</Typography>
                                        <Form.Control
                                            required
                                            value={Instalment1}
                                            onChange={(e) => handleInstalment1Change(e)}
                                            type="number"

                                            style={{ padding: '0.42rem', marginBottom: 14 }}


                                        />
                                        <Form.Control.Feedback type="invalid">
                                            Please Enter valid Instalment1
                                        </Form.Control.Feedback>
                                    </Form.Group>

                                    <Form.Group as={Col} md="4" controlId="validationCustom01">
                                        <Typography style={{ color: 'gray', fontSize: 13 }}>Instalment2</Typography>
                                        <Form.Control
                                            required
                                            value={Instalment2}
                                            onChange={(e) => handleInstalment2Change(e)}
                                            type="number"

                                            style={{ padding: '0.42rem', marginBottom: 14 }}


                                        />
                                        <Form.Control.Feedback type="invalid">
                                            Please Enter Valid Instalment2
                                        </Form.Control.Feedback>
                                    </Form.Group>

                                    <Form.Group as={Col} md="4" controlId="validationCustom01">
                                        <Typography style={{ color: 'gray', fontSize: 13 }}>Instalment3</Typography>
                                        <Form.Control
                                            required
                                            onChange={(e) => handleInstalment3Change(e)}
                                            type="number"
                                            value={Instalment3}
                                            style={{ padding: '0.42rem', marginBottom: 14 }}


                                        />
                                        <Form.Control.Feedback type="invalid">
                                            Please Enter Valid Instalment3
                                        </Form.Control.Feedback>
                                    </Form.Group>


                                    <Form.Group as={Col} md="12" controlId="validationCustom01">
                                        <Typography style={{ color: 'gray', fontSize: 13 }}>Final Payment</Typography>
                                        <Form.Control
                                            required
                                            value={FinalPayment}
                                            onChange={(e) => handleFinalPaymentChange(e)}
                                            type="number"

                                            style={{ padding: '0.42rem', marginBottom: 14 }}
                                        />
                                        <Form.Control.Feedback type="invalid">
                                            Please Enter Valid final payment
                                        </Form.Control.Feedback>
                                    </Form.Group>

                                </Row>
                                <div className='d-flex'>
                                    <div>
                                        <Button type='submit' style={{ width: '9rem', height: '2.3rem', backgroundColor: 'rgb(126, 110, 228)', color: 'white', marginRight: 3 }}>Submit</Button>
                                    </div>
                                    <div>
                                        <Button onClick={() => setOpen(false)} style={{ width: '9rem', height: '2.3rem', backgroundColor: 'gray', color: 'white' }}>Cancel</Button>
                                    </div>
                                </div>
                            </Form>
                        </div>
                    </DialogContent>
                </Dialog>
            </div>

            <div>
                <Dialog
                    style={{ borderTop: '12px solid rgb(126, 110, 228)' }}
                    maxWidth='xl'
                    open={open1}
                    onClose={() => setOpen1(false)}
                    aria-labelledby="responsive-dialog-title"
                >
                    <DialogContent>
                        <div style={{ width: "37rem" }} >
                            <Form noValidate validated={Validated} onSubmit={formValidation} >
                                <div className='mb-4 mt-1'>
                                    <Typography style={{ textAlign: 'center', fontWeight: '500', color: 'rgb(126, 110, 228)', fontSize: 21 }}>Add Payment</Typography>
                                </div>
                                <Row className="mb-3">

                                    <Form.Group as={Col} md="12" controlId="validationCustom01">
                                        <Typography style={{ color: 'gray', fontSize: 13 }}>Project Name</Typography>
                                        <Form.Select
                                            required
                                            onChange={(e) => setProjectName(e.target.value)}
                                            type="text"
                                            value={ProjectName}
                                            style={{ padding: '0.42rem', marginBottom: 14 }}


                                        >
                                            <option>Select Project Name</option>

                                            {
                                                response1.map((data) => {
                                                    return (
                                                        <option>{data.ProjectName}</option>
                                                    )
                                                })
                                            }

                                        </Form.Select>
                                        <Form.Control.Feedback type="invalid">
                                            Please Enter Valid name
                                        </Form.Control.Feedback>
                                    </Form.Group>

                                    <Form.Group as={Col} md="12" controlId="validationCustom01">
                                        <Typography style={{ color: 'gray', fontSize: 13 }}>Down Payment</Typography>
                                        <Form.Control
                                            required
                                            onChange={(e) => handleDownPaymentChange(e)}
                                            type="number"
                                            maxLength="2"
                                            style={{ padding: '0.42rem', marginBottom: 14 }}
                                        />
                                        <Form.Control.Feedback type="invalid">
                                            Please Enter a valid down payment (up to 100%)
                                        </Form.Control.Feedback>
                                    </Form.Group>


                                    <Form.Group as={Col} md="4" controlId="validationCustom01">
                                        <Typography style={{ color: 'gray', fontSize: 13 }}>Instalment1</Typography>
                                        <Form.Control
                                            required
                                            onChange={(e) => handleInstalment1Change(e)}
                                            type="number"

                                            style={{ padding: '0.42rem', marginBottom: 14 }}


                                        />
                                        <Form.Control.Feedback type="invalid">
                                            Please Enter valid Instalment1
                                        </Form.Control.Feedback>
                                    </Form.Group>

                                    <Form.Group as={Col} md="4" controlId="validationCustom01">
                                        <Typography style={{ color: 'gray', fontSize: 13 }}>Instalment2</Typography>
                                        <Form.Control
                                            required
                                            onChange={(e) => handleInstalment2Change(e)}
                                            type="number"

                                            style={{ padding: '0.42rem', marginBottom: 14 }}


                                        />
                                        <Form.Control.Feedback type="invalid">
                                            Please Enter Valid Instalment2
                                        </Form.Control.Feedback>
                                    </Form.Group>

                                    <Form.Group as={Col} md="4" controlId="validationCustom01">
                                        <Typography style={{ color: 'gray', fontSize: 13 }}>Instalment3</Typography>
                                        <Form.Control
                                            required
                                            onChange={(e) => handleInstalment3Change(e)}
                                            type="number"

                                            style={{ padding: '0.42rem', marginBottom: 14 }}


                                        />
                                        <Form.Control.Feedback type="invalid">
                                            Please Enter Valid Instalment3
                                        </Form.Control.Feedback>
                                    </Form.Group>


                                    <Form.Group as={Col} md="12" controlId="validationCustom01">
                                        <Typography style={{ color: 'gray', fontSize: 13 }}>Final Payment</Typography>
                                        <Form.Control
                                            required
                                            onChange={(e) => handleFinalPaymentChange(e)}
                                            type="number"

                                            style={{ padding: '0.42rem', marginBottom: 14 }}
                                        />
                                        <Form.Control.Feedback type="invalid">
                                            Please Enter Valid final payment
                                        </Form.Control.Feedback>
                                    </Form.Group>

                                </Row>
                                <div className='d-flex'>
                                    <div>
                                        <Button onClick={() => editAlert(id)} style={{ width: '9rem', height: '2.3rem', backgroundColor: 'rgb(126, 110, 228)', color: 'white', marginRight: 3 }}>Update</Button>
                                    </div>
                                    <div>
                                        <Button onClick={() => setOpen1(false)} style={{ width: '9rem', height: '2.3rem', backgroundColor: 'gray', color: 'white' }}>Cancel</Button>
                                    </div>
                                </div>
                            </Form>
                        </div>
                    </DialogContent>
                </Dialog>
            </div>
         
        </div>
    );
}